import { render, staticRenderFns } from "./deptUpload.vue?vue&type=template&id=4b98b45a&scoped=true&"
import script from "./deptUpload.vue?vue&type=script&lang=js&"
export * from "./deptUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98b45a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b98b45a')) {
      api.createRecord('4b98b45a', component.options)
    } else {
      api.reload('4b98b45a', component.options)
    }
    module.hot.accept("./deptUpload.vue?vue&type=template&id=4b98b45a&scoped=true&", function () {
      api.rerender('4b98b45a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/deptUpload.vue"
export default component.exports